import emojione from 'emojione/lib/js/emojione.js'
import config from '../config'
import each from 'lodash/each'

export function convertEmojiHTML(html) {
  return html.replace(/ ?:emoji-([-0-9a-f]+): ?/ig, (match, unicode)=> {
    return `<img src="${config.emojiPNG}${unicode.toLowerCase()}.png" style="width: 18px; height: 18px; vertical-align: middle"/>`
  }).replace(/\uFE0F/g, '')
}

export function convertEmojiChar(text) {
  return text.replace(/ ?:emoji-([-0-9a-f]+): ?/ig, (match, unicode)=> {
    var buf = ''
    each(unicode.split('-').map((code)=> { return parseInt(code, 16); }), (code)=> {
      if (code < 0x10000) {
        buf += String.fromCharCode(code)
      } else {
        code -= 0x10000
        buf += String.fromCharCode(0xD800 + (code >> 10), 0xDC00 + (code & 0x3FF))
      }
    })
    return buf
  })
}

export function encodeEmojiTag(html) {
  return html.replace(/<img [^>]*src="[.:\/\w\d]+emojione[.:\/\d\w]*\/([-0-9a-f]+).png"[^>]*>/g, " :emoji-$1: ")
}



// WEBPACK FOOTER //
// ./src/helpers/emoji-helpers.js